import styled from 'styled-components';
const HorizontalBlogWrapper = styled.div`    
    .blog-cover {
        height: 100%;
        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
        }
    }
`;

export default HorizontalBlogWrapper;